export function getFileExtension(fileName: string): string {
    // https://www.jstips.co/en/javascript/get-file-extension/
    // adding toLowerCase to avoid having case sensitivity
    return fileName.toLowerCase().slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2);
}
